import {
  DATA_DURATION_OPTIONS_COMPLETED,
  DATA_DURATION_OPTIONS_PROJECTED,
} from '../../../constants/trialDeliveryGoal.constants';

export const CRITICAL_MILESTONES_COMPLETED_CARD = [
  {
    title: 'Clinical milestones completed on plan',
    key: 'CRITICAL_MILESTONES_COMPLETED_CARD_1',
  },
  {
    title: 'Median variance from plan',
    key: 'CRITICAL_MILESTONES_COMPLETED_CARD_2',
  },
];

export const CRITICAL_MILESTONES_PROJECTED_CARD = [
  {
    title: 'Clinical milestones on target',
    key: 'CRITICAL_MILESTONES_PROJECTED_CARD_1',
  },
  {
    title: 'Median variance from plan',
    key: 'CRITICAL_MILESTONES_PROJECTED_CARD_2',
  },
];

export const CRITICAL_MILESTONES_SECTION_CONTENT = {
  GROUP: [
    {
      label: 'Completed',
      value: 'COMPLETED',
      duration: DATA_DURATION_OPTIONS_COMPLETED,
    },
    {
      label: 'Projected',
      value: 'PROJECTED',
      duration: DATA_DURATION_OPTIONS_PROJECTED,
    },
  ],
};

export const CLINICAL_MILESTONES_TABLE_EXPORT = [
  {
    label: 'Trial',
    value: 'protocolNumberHarmonized',
    colWidth: { wch: 20 },
  },
  {
    label: 'Clinical milestone',
    value: 'clinicalMilestone',
    colWidth: { wch: 15 },
  },
  {
    label: 'Rag Status',
    value: 'status',
    colWidth: { wch: 15 },
  },
  {
    label: 'Planned date',
    value: 'plannedDate',
    colWidth: { wch: 15 },
  },
  {
    label: 'Forecast date',
    value: 'forecastDate',
    colWidth: { wch: 15 },
  },
  {
    label: 'Variance from plan',
    value: 'varianceFromPlan',
    colWidth: { wch: 15 },
  },
];
